import { useEffect } from 'react';
import { Icono } from '../components/Iconos';
import type { Aviso } from './contexto';

const ICONO = { info: 'info', exito: 'exito', error: 'alerta', alerta: 'excepciones' } as const;

function UnAviso({ a, alCerrarId }: { a: Aviso; alCerrarId: (id: number) => void }) {
  const alCerrar = () => alCerrarId(a.id);
  useEffect(() => {
    const t = setTimeout(() => alCerrarId(a.id), a.tono === 'error' ? 9000 : 5000);
    return () => clearTimeout(t);
  }, [a, alCerrarId]);
  return (
    <div className={`aviso-flotante aviso-flotante--${a.tono}`} role={a.tono === 'error' ? 'alert' : 'status'}>
      <span className="aviso-flotante__icono">
        <Icono nombre={ICONO[a.tono]} tam={20} />
      </span>
      <div className="aviso-flotante__texto">
        <strong>
          {a.texto}
          {a.regla && <span className="etiqueta-regla">{a.regla}</span>}
        </strong>
        {a.detalle && <p>{a.detalle}</p>}
        {a.accion && (
          <button
            type="button"
            className="enlace-boton"
            onClick={() => {
              a.accion?.alHacer();
              alCerrar();
            }}
          >
            {a.accion.texto}
          </button>
        )}
      </div>
      <button type="button" className="btn-icono btn-icono--mini" aria-label="Cerrar aviso" onClick={alCerrar}>
        <Icono nombre="cerrar" />
      </button>
    </div>
  );
}

export function Avisos({ avisos, alCerrar }: { avisos: Aviso[]; alCerrar: (id: number) => void }) {
  return (
    <div className="avisos" aria-live="polite">
      {avisos.map((a) => (
        <UnAviso key={a.id} a={a} alCerrarId={alCerrar} />
      ))}
    </div>
  );
}
